import cx from "classnames";
import React from "react";
import Button from "@trainline-shareable/button";
import IconClose from "../assets/IconClose";
import * as styles from "./OverlayHeader.module.css";
const OverlayHeader = ({
  testId = "overlay",
  content,
  actionButtons,
  type,
  showShadow,
  onClose
}) => /* @__PURE__ */ React.createElement("div", {
  className: cx(styles.root, {
    [styles.overlayHeaderBubble]: type === "bubble",
    [styles.overlayHeaderShadow]: showShadow
  }),
  "data-testid": `${testId}-header`
}, content && /* @__PURE__ */ React.createElement("div", {
  className: styles.overlayHeaderContent,
  "data-testid": `${testId}-header-content`
}, content), /* @__PURE__ */ React.createElement("div", {
  className: styles.overlayHeaderActionButtons,
  "data-testid": `${testId}-header-action-buttons`
}, actionButtons || /* @__PURE__ */ React.createElement(Button, {
  type: "button",
  variant: "ghost",
  className: styles.overlayHeaderActionButton,
  "data-testid": `${testId}-header-close-btn`,
  title: "close",
  "aria-label": "close",
  onClick: (e) => {
    e.stopPropagation();
    return onClose();
  }
}, /* @__PURE__ */ React.createElement(IconClose, null))));
var OverlayHeader_default = OverlayHeader;
export {
  OverlayHeader_default as default
};
